// src/components/AboutUs.js
import { useState, useEffect } from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";

const CONTACT = {
  phone: "0554327448",
  phoneIntl: "+966554327448",
  email: "admin@trustfixs.com",
};

const CONTENT = {
  ar: {
    docTitle: "ترستفيكس",
    subtitle: "تطبيق ترستفيكس — TrustFix",
    lede: "منصّة إلكترونية رائدة لخدمات الصيانة والخدمات المنزلية في المملكة العربية السعودية. نربط العملاء بأقرب مقدّمي الخدمة الموثوقين عبر نظام إسنادٍ فوري، ونوفّر تجربةً سريعةً وآمنةً من طلب الخدمة حتى إتمامها — مع دفعٍ إلكترونيٍّ موثوق ودعمٍ باللغتين العربية والإنجليزية.",    aboutTitle: "من نحن",
    about:
      "الموقع الإلكتروني هو ملك لمؤسسة ترستفيكس، المسجلة لدى وزارة التجارة في المملكة العربية السعودية بالرقم الوطني الموحد (7021874339) والسجل التجاري رقم (7021874339). ترستفيكس منصّة سعودية تجمع بين العملاء ومقدّمي خدمات الصيانة والخدمات المنزلية بنظام إسنادٍ فوري. نوفّر طريقةً سريعةً وموثوقةً لطلب الخدمة من أقرب فنّي متاح، مع دفعٍ إلكترونيٍّ آمن ودعمٍ باللغتين العربية والإنجليزية.",
    contactTitle: "معلومات التواصل",
    phoneLabel: "الهاتف",
    emailLabel: "البريد الإلكتروني",
    addressLabel: "العنوان",
    address: "RQNE7434، حي النسيم الشرقي، الرياض، المملكة العربية السعودية",
  },
  en: {
    docTitle: "TrustFix",
    subtitle: "TrustFix",
    lede: "A leading online platform for maintenance and home services in the Kingdom of Saudi Arabia. We connect customers with the nearest trusted service providers through instant dispatch, delivering a fast, secure experience from request to completion — with reliable electronic payment and support in both Arabic and English.",    aboutTitle: "About Us",
    about:
      "The website is owned by Trustfix Establishment, registered with the Ministry of Commerce in the Kingdom of Saudi Arabia with the unified national number (7021874339) and commercial registration number (7021874339). TrustFix is a Saudi platform connecting customers with maintenance and home-service providers through instant dispatch. We offer a fast, reliable way to request a service from the nearest available technician, with secure electronic payment and support in both Arabic and English.",
    contactTitle: "Contact",
    phoneLabel: "Phone",
    emailLabel: "Email",
    addressLabel: "Address",
    address: "RQNE7434, East Naseem Dist., Riyadh, Saudi Arabia",
  },
};

export default function AboutUs() {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("tf_lang") || "ar";
    } catch {
      return "ar";
    }
  });

  const isAr = lang === "ar";
  const t = CONTENT[lang];

  useEffect(() => {
    try {
      localStorage.setItem("tf_lang", lang);
    } catch {}
  }, [lang]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header lang={lang} setLang={setLang} />
      <div className="min-h-screen" dir={isAr ? "rtl" : "ltr"}>
        <section>
          <div className="max-w-4xl mx-auto px-5 pt-3 pb-3">
            <h1 className="text-[26px] font-extrabold text-[#006C35] mt-2 mb-1">
              {t.docTitle}
            </h1>
            <p className="text-gray-500 text-[15px] mt-0 mb-4">{t.subtitle}</p>
            <p className="text-gray-600 leading-relaxed max-w-2xl mb-6">
              {t.lede}
            </p>
          </div>
        </section>

        <section className="bg-white">
          <div className="max-w-4xl mx-auto px-5 pt-8 pb-12">
            {/* About */}
            <h2 className="text-lg font-bold text-[#006C35] mb-2">
              {t.aboutTitle}
            </h2>
            <p className="text-gray-700 leading-relaxed mb-8">{t.about}</p>

            {/* Contact info */}
            <h2 className="text-lg font-bold text-[#006C35] mb-4">
              {t.contactTitle}
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 shrink-0 bg-[#EDEEF2] rounded-lg flex items-center justify-center">
                  <Phone size={18} className="text-[#535C79]" />
                </div>
                <div>
                  <div className="text-sm text-gray-500">{t.phoneLabel}</div>
                  <a
                    href={`tel:${CONTACT.phoneIntl}`}
                    dir="ltr"
                    className="text-gray-800 font-semibold hover:text-[#006C35] transition-colors"
                  >
                    {CONTACT.phone}
                  </a>
                </div>
              </li>

              <li className="flex items-start gap-3">
                <div className="w-10 h-10 shrink-0 bg-[#EDEEF2] rounded-lg flex items-center justify-center">
                  <Mail size={18} className="text-[#535C79]" />
                </div>
                <div>
                  <div className="text-sm text-gray-500">{t.emailLabel}</div>
                  <a
                    href={`mailto:${CONTACT.email}`}
                    dir="ltr"
                    className="text-gray-800 font-semibold hover:text-[#006C35] transition-colors"
                  >
                    {CONTACT.email}
                  </a>
                </div>
              </li>

              <li className="flex items-start gap-3">
                <div className="w-10 h-10 shrink-0 bg-[#EDEEF2] rounded-lg flex items-center justify-center">
                  <MapPin size={18} className="text-[#535C79]" />
                </div>
                <div>
                  <div className="text-sm text-gray-500">{t.addressLabel}</div>
                  <span className="text-gray-800 font-semibold">
                    {t.address}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}